import React from 'react';
import { Link } from 'react-router-dom';
import TubitakLogo from '../../assets/img/slider/tubitak-logo.svg';

const CTA = () => {
  return (
    <div
      className="cta__area cta__bg cta__plr p-relative wow animate__fadeInUp"
      data-wow-duration="1.1s"
      style={{ 
        backgroundColor: '#2a3658',
        padding: 'clamp(30px, 4vw, 45px) 0'
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="cta__section-wrapper text-center">
              <div className="cta__section-box" style={{ padding: '0' }}>
                <h4
                  className="cta__title wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                  data-wow-delay=".7s"
                  style={{ 
                    color: '#ffffff',
                    fontSize: 'clamp(24px, 3.5vw, 32px)',
                    marginBottom: 'clamp(14px, 2vw, 18px)',
                    fontWeight: '700'
                  }}
                >
                  Denizcilik Teknolojilerinde Geleceği Birlikte Şekillendirelim
                </h4>
                <p 
                  className="wow animate__fadeInUp" 
                  data-wow-duration="1.1s"
                  style={{ 
                    color: '#ffffff',
                    fontSize: 'clamp(16px, 2vw, 18px)',
                    lineHeight: '1.8',
                    maxWidth: '900px',
                    margin: '0 auto',
                    padding: '0 20px'
                  }}
                >
                  Projelerimiz, Türkiye Bilimsel ve Teknolojik Araştırma Kurumu (TÜBİTAK) tarafından desteklenmektedir. 
                  İnsansız Su Altı Robotumuz, TÜBİTAK 1512 BİGG programı kapsamında desteklenmiş ve proje başarıyla tamamlanmıştır. 
                  Robotik Kol Projesi ise TÜBİTAK 1507 KOBİ Ar-Ge Başlangıç Destek Programı kapsamında desteklenmektedir. 
                  Bu destekler sayesinde, denizcilik sektörüne yönelik yerli teknoloji geliştirme çalışmalarımızı sürdürmekteyiz.
                </p>
                <div 
                  className="wow animate__fadeInUp" 
                  data-wow-duration="1.1s"
                  data-wow-delay=".3s"
                  style={{ 
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 'clamp(18px, 2.5vw, 24px)'
                  }}
                >
                  <img 
                    src={TubitakLogo} 
                    alt="TÜBİTAK Logo" 
                    style={{ 
                      width: '250px',
                      height: 'auto',
                      objectFit: 'contain',
                      filter: 'brightness(0) invert(1)'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTA;
